export enum WorkLocationTypeCodes {
  DEPARTMENT = 1,
  PROJECT,
  PLANT,
  FORMWORK,
  STORE,
  FACTORY,
  FORM_HOUSE,
}
